import HearingSummary from 'components/HearingSummary'
import Layout from 'layouts/Default'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import summaryService from 'services/summary.service'
import { hearingSummaryInit, HearingSummaryType } from 'types/hearing-summary.type'

const ViewSummaryHearing: React.FC = () => {
  const { id: hearingId } = useParams()

  const [document, setDocument] = useState<HearingSummaryType>(hearingSummaryInit)

  const buttonDownloadRef = useRef<null | HTMLDivElement>(null)

  const getTeenagerById = useCallback(async (): Promise<void> => {
    try {
      if (!hearingId) return
      const res = await summaryService.getById(hearingId)
      if (res.data) setDocument(res.data)
    } catch (err) {
      console.log('General Data Request: ', err)
    }
  }, [hearingId])

  useEffect(
    () => buttonDownloadRef.current?.scrollIntoView({ behavior: 'smooth' }),
    [document.dadosGerais],
  )

  useEffect(() => {
    getTeenagerById()
  }, [getTeenagerById])

  return (
    <Layout>
      <HearingSummary data={document} />
    </Layout>
  )
}

export default ViewSummaryHearing
